export default "__VITE_ASSET__B$3Uv1$O__"